module.exports = __webpack_public_path__ + "static/media/Screenshot_3.5d81015c.png";